import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgDialogModule } from '@principle-theorem/ng-shared';
import { InitReferralData } from '@principle-theorem/principle-core';
import {
  IBrand,
  IPatient,
  IPractice,
  IStaffer,
} from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';
import { ReferralFormComponent } from '../referral-form/referral-form.component';

export interface IReferralCreateDialogData {
  brand: WithRef<IBrand>;
  staffer: WithRef<IStaffer>;
  practice: WithRef<IPractice>;
  patient?: WithRef<IPatient>;
}

@Component({
  selector: 'pr-referral-create-dialog',
  imports: [NgDialogModule, ReferralFormComponent],
  templateUrl: './referral-create-dialog.component.html',
  styleUrl: './referral-create-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralCreateDialogComponent {
  dialogRef = inject(MatDialogRef<ReferralCreateDialogComponent>);
  data = inject<IReferralCreateDialogData>(MAT_DIALOG_DATA);
  referralData = signal<InitReferralData | undefined>(undefined);

  createReferral(): void {
    const data = this.referralData();
    if (!data) {
      return;
    }
    this.dialogRef.close(data);
  }
}
